module.exports = __webpack_public_path__ + "img/536.fece30e8.jpg";